import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import ExhibitionsPreview from '../ExhibitionsPreview';

const useStyles = makeStyles(() =>
    createStyles({
        panelRelatedExhitions: {
            position: 'relative',
            width: `100%`,

            [mediaQueries.Mobile]: {
                paddingBottom: `${spacing.Gutter.Mobile - spacing.GutterGrid.Mobile}px`,
            },
            [mediaQueries.Tablet]: {
                paddingBottom: `${spacing.Gutter.Tablet - spacing.GutterGrid.Tablet}px`,
            },
            [mediaQueries.Laptop]: {
                paddingBottom: `${spacing.Gutter.Laptop - spacing.GutterGrid.Laptop}px`,
            },
            [mediaQueries.Desktop]: {
                paddingBottom: `${spacing.Gutter.Desktop - spacing.GutterGrid.Desktop}px`,
            },
            [mediaQueries.BigDesktop]: {
                paddingBottom: `${spacing.Gutter.BigDesktop - spacing.GutterGrid.BigDesktop}px`,
            }
        },
        panelRelatedExhitionsInner: {
            display: 'flex',
            flexWrap: 'wrap',
        },
    }));

export type PanelRelatedExhibitionsProps = PanelRelatedExhibitionsDto;

type Props = PanelRelatedExhibitionsProps;

const PanelRelatedExhibitions: FC<Props> = ({ ExhibitionsPreviews, FairsPreviews }) => {
    const cls = useStyles();

    const panels = ExhibitionsPreviews.length > 0 ? 
        ExhibitionsPreviews : FairsPreviews.length > 0 ? 
        FairsPreviews : undefined;

    return (
        <div className={cls.panelRelatedExhitions}>
            <div className={cls.panelRelatedExhitionsInner}>
                {panels &&
                    panels.map((item, i) =>
                        <ExhibitionsPreview {...item} key={item.UID} delayIndex={i} />)
                }
            </div>
        </div>
    );
};

export default PanelRelatedExhibitions;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelRelatedExhibitions.tsx